export default "__VITE_ASSET__eJskhLeP__"